
import { defineComponent, ref, computed } from "vue";
import { GameUtils } from "@/utils/GameUtils";
import { Game } from "@/_models/Game";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useMeta } from "vue-meta";

export default defineComponent({
  name: "viewGamesGenre",
  components: {
  },
  setup() {
    let totalGames;
    const pages = ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);
    const route = useRoute();
    const store = useStore();
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const metaTitle = ref('MetaXar Gamer Dashboard');
    const metaDescription = ref('MetaXar Gamer Dashboard Description');
    useMeta({ title: metaTitle.value, description: metaDescription.value });
    const featuredTitle = ref("Featured Game's Title Will Go Here");
    const questionTitle = ref("Lorem ipsum dolor sit amet, consectetur adipiscing elit.");
    const questionDesc = ref("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. ");
    const coinTitle = ref("Top Xar Coins");
    const coinName = ref("XARTempo");
    const coinSubtitle = ref("Temporary Subtitle");
    const coinNum = ref("5,324");
    const iconNum = ref("512+");
    const iconTitle = ref("Dummy Title Here");
    const games = ref([]);
    const genreGames = ref([]);
    const displayGames = ref([]);
    const publishedGames = ref([]);
    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });
    const Genre = ref();
    const Genres = ref([]);
    const sortedGenre = ref([]);
    const Action = ref([]);
    const Adventure = ref([]);
    const Simulation = ref([]);
    const Strategy = ref([]);
    const Sports = ref([]);
    const Fantasy = ref([]);
    const Arcade = ref([]);
    const Horror = ref([]);


    (async () => {
      Genre.value = route.params.category;
      games.value = await GameUtils.fetchAllPublishedGames();
      Genres.value = await GameUtils.fetchGenreCount();
      const nestedSort = (prop1, prop2 = null, direction = 'asc') => (e1, e2) => {
        const a = prop2 ? e1[prop1][prop2] : e1[prop1],
          b = prop2 ? e2[prop1][prop2] : e2[prop1],
          sortOrder = direction === "asc" ? 1 : -1
        return (a < b) ? -sortOrder : (a > b) ? sortOrder : 0;
      }

      sortedGenre.value = Genres.value.sort(nestedSort("count", null, "desc"))
      genreGames.value = await GameUtils.fetchGenrePublishedGame(Genre.value);
      if (Genre.value != null) {
        totalGames = genreGames.value.length;
        totalPages.value = Math.ceil(totalGames / pages.value);
        displayGames.value = genreGames.value.slice(
          (currentPage.value - 1) * pages.value,
          Number((currentPage.value - 1) * pages.value) + Number(pages.value)
        );
      } else {
        totalGames = games.value.length;
        totalPages.value = Math.ceil(totalGames / pages.value);
        displayGames.value = games.value.slice(
          (currentPage.value - 1) * pages.value,
          Number((currentPage.value - 1) * pages.value) + Number(pages.value)
        );
      }
    })()

    const loadGames = () => {
      if (Genre.value != null) {
        totalPages.value = Math.ceil(genreGames.value.length / pages.value);
        displayGames.value = genreGames.value.slice(
          (currentPage.value - 1) * pages.value,
          Number((currentPage.value - 1) * pages.value) + Number(pages.value)
        );
      } else {
        totalPages.value = Math.ceil(games.value.length / pages.value);
        displayGames.value = games.value.slice(
          (currentPage.value - 1) * pages.value,
          Number((currentPage.value - 1) * pages.value) + Number(pages.value)
        );
      }
    };
    loadGames();

    const enableFirstPage = computed(() => {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const enableNextPage = computed(() => {
      return totalPages.value - currentPage.value > 0;
    });

    const enableLastPage = computed(() => {
      return currentPage.value < totalPages.value;
    });

    const naviFirst = () => {
      currentPage.value = 1;
      loadGames();
    };

    const naviPrevious = () => {
      --currentPage.value;
      loadGames();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadGames();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadGames();
    };

    const changeRows = () => {
      loadGames();
    };


    return {
      games,
      genreGames,
      label,
      featuredTitle,
      questionTitle,
      questionDesc,
      coinTitle,
      coinName,
      coinSubtitle,
      coinNum,
      iconNum,
      iconTitle,
      assetURL,
      pages,
      currentPage,
      totalPages,
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      enableLastPage,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,
      displayGames,
      publishedGames,
      Genre,
      Genres,
      sortedGenre,
      Action,
      Adventure,
      Simulation,
      Strategy,
      Sports,
      Fantasy,
      Arcade,
      Horror,
    };
  },
});


